import React, { PropsWithChildren, useEffect, useState } from 'react';
import { DialogContentContainer } from '../styled';
import { PCRModel } from 'services/EpdClient';
import CPcrSelectorDialogForm from './CPcrSelectorDialogForm';
import { PrimaryButton, SecondaryButton } from 'components/v2/buttons';
import { HelpBox } from 'components/v2/help-boxes';
import { useScrollShadow } from 'hooks/useScrollShadow';
import styled from 'styled-components';
import { ScrollShadowDialog } from 'styles/Styles.styled';

type TProps = PropsWithChildren<{
  visible: boolean;
  onHide(): void;
  initialCpcr: PCRModel | null;
  onCpcrChange(cpcr: PCRModel): void;
  cpcrList: PCRModel[];
  disclaimerText?: React.ReactNode;
}>;

const CPcrSelectorDialog = ({ visible, onHide, initialCpcr, onCpcrChange, cpcrList, disclaimerText }: TProps) => {
  const [selectedCpcr, setSelectedCpcr] = useState<PCRModel | null>(initialCpcr);

  useEffect(() => {
    if (visible) setSelectedCpcr(initialCpcr);
  }, [visible, initialCpcr]);

  const { isScrolled, contentRef } = useScrollShadow();

  return (
    <StyledDialog
      visible={visible}
      $isScrolled={isScrolled}
      onHide={onHide}
      header="Add Complementary Product Category Rule (C-PCR)"
      contentStyle={cpcrList?.length > 0 ? {} : { overflowY: 'initial' }}
      resizable={false}
      style={{ width: '35rem' }}
      footer={
        <>
          <SecondaryButton label="Cancel" onClick={onHide} outlined />
          <PrimaryButton
            label="Add"
            onClick={() => {
              if (selectedCpcr) {
                onCpcrChange(selectedCpcr);
              }
              onHide();
            }}
            autoFocus
            disabled={!selectedCpcr}
          />
        </>
      }
    >
      <DialogContentContainer ref={contentRef}>
        {disclaimerText && <HelpBox style={{ marginBottom: '1rem' }}>{disclaimerText}</HelpBox>}
        <CPcrSelectorDialogForm cpcrList={cpcrList} selectedCpcr={selectedCpcr} onSelectedCpcrChange={setSelectedCpcr} />
      </DialogContentContainer>
    </StyledDialog>
  );
};

const StyledDialog = styled(ScrollShadowDialog)`
  .p-dialog-header-close {
    display: none;
  }
`;

export default CPcrSelectorDialog;
